import { CardWrapper } from "./CardWrapper";
import { Stack, Typography } from "@mui/material";
import { TextBlock } from "./TextBlock";
import { CardList } from "./CardList";
import { PlaybookList } from "./PlaybookList";
import { BigBgTopSquareIcon } from "../../../images";
import { H4Component } from "./H4Component";
import { ReadFirstType } from "../../../../types";
import { useEffect } from "react";

export const ReadFirstBlock = ({
  description,
  company_context,
  common_pain_points,
  what_will_help,
  what_we_know,
  keep_in_mind,
  lead_company,
  setTopic,
}: ReadFirstType & {
  lead_company: string;
  setTopic: (topic: string) => void;
}) => {
  const topic = "Understanding the Prospect Type";

  useEffect(() => {
    setTopic(topic);
  }, [topic]);

  return (
    <CardWrapper isCard={true}>
      <BigBgTopSquareIcon
        style={{
          position: "absolute",
          top: "0",
          right: "80px",
          flexDirection: "row",
        }}
      />
      <BigBgTopSquareIcon
        style={{
          position: "absolute",
          top: "0",
          right: "-52px",
          flexDirection: "row",
        }}
      />

      <Stack gap="28px" id={topic}>
        <Stack gap="20px">
          <Typography
            component="h4"
            sx={{
              fontSize: "22px",
              lineHeight: "28px",
              fontWeight: 600,
              color: "#005EAB",
            }}
          >
            {topic} <span style={{ color: "#FE8836" }}>(Read This First) </span>
          </Typography>
          <TextBlock text={description} />
        </Stack>

        {company_context && company_context.length > 0 && !!lead_company && (
          <Stack gap="8px">
            <H4Component
              text={`Account Overview for ${lead_company}`}
              color={"#024760"}
            />
            <TextBlock text={company_context} />
          </Stack>
        )}
        {keep_in_mind && keep_in_mind.length > 0 && (
          <CardList title={"Keep In Mind:"} items={keep_in_mind} />
        )}

        {what_we_know && (
          <PlaybookList
            title={"What We Currently Know:"}
            items={what_we_know}
          />
        )}

        {common_pain_points && (
          <PlaybookList
            title={"Common Pain Points and Goals:"}
            items={common_pain_points}
          />
        )}

        {common_pain_points && (
          <PlaybookList
            title={"What Will Help You Succeed:"}
            items={what_will_help}
          />
        )}
      </Stack>
    </CardWrapper>
  );
};
